// ═══════════════════════════════════════════════════════════════
//  CONFIGURATION DES UTILISATEURS — EMS
//  Modifier ce fichier pour gérer les comptes autorisés.
//  En production, remplacer par une vraie API d'authentification.
// ═══════════════════════════════════════════════════════════════

export const USERS = [
  {
    email:    "admin@greenarrows.energy",
    password: "Greenarrows@2026",
    name:     "Admin",
    initials: "GA",
    role:     "admin",
  },
  // Ajouter d'autres utilisateurs ici :
  // {
  //   email:    "operateur@greenarrows.energy",
  //   password: "Operateur@2026",
  //   name:     "Operateur",
  //   initials: "OP",
  //   role:     "operator",
  // },
]
